import axios from "../../../lib/httpclient"

class BloodBankRepository {}

export default new BloodBankRepository()
